import React from 'react';
import PropTypes from 'prop-types';
import { Link, navigate } from 'gatsby';
import Layout from 'components/Layout/Layout.component';
import SEO from 'components/SEO';
import { productItems, productDropdownItems } from 'config/productItems';
import VersionSelector from 'components/VersionSelector/VersionSelector.component';
import ButtonSelector from 'components/ButtonSelector/ButtonSelector.component';
// import SolutionsIcon from 'images/icons/solutions.inline.svg'
import Notice from 'components/Notice/Notice.component'
import ArrowRight from 'images/icons/arrow-right.inline.svg'
import {
   title, 
   description, 
  //  solutionsItems, 
   whatsNewItems 
} from 'config/homePage';
import '../utils/styles/home-page.scss';  



const LandingPageHome = ({
  path 
}) => {

  const handleChange = (prod) => {
    // console.log({prod})
    navigate(prod.link)
  }

  return (
    <Layout pathname={path} title="Home" >
        <div className="home-wrap">
          <h1 style={{fontSize: '2rem', marginBottom: '0.25em'}}>{title}</h1>
          <p style={{maxWidth: '90ch'}}>{description}</p>

          <Notice />

          <h2 style={{marginBottom: '0em', marginTop: '2rem'}}>Explore Our Solutions</h2>
          <p style={{maxWidth: '90ch', marginBottom: '1rem'}}>Our portfolio of search and discovery solutions are designed to address a multitude of technical requirements. Select a product below to get started.</p>
          <div >
            <div className="home-grid">
              {
                productItems.filter(prod => prod.isHomeGrid).map((item, indx) => {
                  return (
                    <div key={item.tag} className={`home-grid-itm col--${indx}x`}>
                      { item.versions ? 
                          <VersionSelector
                            handleChange={handleChange}
                            display='fit'
                            selectedOption={{
                              label: item?.versions ? item.versions.at(-1) : item.name,
                              link: item.link,
                              tag: item.tag,
                              value: `${item.name === 'Fusion Server' ? 'Fusion' : item.name} ${item?.versions ? `${item?.versions.at(-1)}` : ''}`
                            }}
                            options={productDropdownItems.filter(itm => itm.tag === item.tag)}
                          /> 
                        : 
                          <ButtonSelector 
                            link={item.alternateLink}
                            title={item.subMenu !== 'Fusion 4' ? item.name : item.subMenu}
                          />
                      }
                      <p>{item.description}</p>
                      <div className="home-itm-highlight">
                        {
                          item?.highlight ? <>
                            {
                              item.highlight.map(itm => (
                                <Link to={itm.link} className={itm.icon} key={itm.icon}>
                                  <span className='underline'>{itm.title}</span>
                                </Link>
                              ))
                            }
                          </> : null
                        }
                      </div>

                      <button 
                        style={{fontSize:'0.8rem'}} 
                        className="button-view-more" 
                        type="button" 
                        onClick={() => { navigate(item.alternateLink)}}>
                          <span style={{display: 'flex', alignItems: 'center'}}>
                            View More
                            <ArrowRight  style={{width: '15px', marginLeft: '0.5em'}}/>
                          </span>
                      </button>

                    </div>
                  )
                })
              }
            </div>
          </div>

          {/* <div style={{marginTop: '5rem'}} className="solutions-wrap">
            <h2 style={{textAlign: 'center'}}>Lucidworks Solutions</h2>
            <div className="solutions-grid">
              {
                solutionsItems.map(itm => (
                  <div className="solutions-card" key={itm.title}>
                    <SolutionsIcon style={{borderRadius: '100%', background: `${itm.gradient}`}}/>
                    <Link to={itm.link} style={{display:'block', margin:'1.25rem 0 1rem 0'}}>
                      <span className="underline">{itm.title}</span>
                    </Link>
                    <p>{itm.description}</p>
                  </div>
                ))
              }
            </div>
          </div> */}

          <div>
            <h2 style={{marginBottom: '0.25em'}}>What&apos;s new</h2>
            <p style={{ marginBottom: '1rem'}}>Recent articles of interest</p>

            <div className="card-grid">
                {
                  whatsNewItems.map(itm => (
                    <div className="card" key={itm.title} style={{background: 'var(--block-color)'}}>
                        <Link to={itm.link}><span className="underline">{itm.title}</span></Link>
                        <p style={{marginTop:'1em'}}>{itm.description}</p>
                      </div>
                  ))
                }
            </div> 
          </div>
        </div>
    </Layout>
  );
};

LandingPageHome.propTypes = {
  path: PropTypes.string.isRequired,
};

export default LandingPageHome;


export function Head(){
  return(
    <SEO title="Home" slug='/' />
  )
}


